import flatpickr from 'flatpickr';
import rangePlugin from 'flatpickr/dist/esm/plugins/rangePlugin';
import { Russian } from 'flatpickr/dist/esm/l10n/ru';

// Проверяем размер экрана, чтобы определить устройство
if (window.innerWidth <= 768) {
    document.querySelector('#booking-modal').style.display = "none";
}
let isPricing = false;
let priceOk = false; // флаг успешного получения цены по API
// Идентификатор последнего ценового запроса, чтобы применить только самый актуальный ответ
window.priceRequestId = 0;
// Защита от рекурсии: true пока мы сами программно меняем даты в flatpickr
let isInternalCalendarUpdate = false;
// AbortController для отмены предыдущего calculate-запроса
let priceAbortController = null;

function isFormValid() {
    const arrivalDate = document.getElementById("arrival-date");
    const departureDate = document.getElementById("departure-date");
    const phoneInput = document.getElementById("phoneNo");
    const guestsInput = document.getElementById("guests");

    return arrivalDate?.value.trim() &&
        departureDate?.value.trim() &&
        phoneInput?.value.trim() &&
        guestsInput?.value.trim();
}

function setBookButtonState() {
    const bookButton = document.getElementById('lockDates');
    if (!bookButton) return;

    const valid = !isPricing && priceOk && isFormValid();
    bookButton.disabled = !valid;

    bookButton.classList.toggle('is-loading', isPricing);
    bookButton.setAttribute('aria-busy', String(isPricing));
}

function saveBookingDraft() {
    let priceText = document.querySelector("#price-details .totalPriceSpan")?.textContent || "0";
    let priceValue = parseFloat(priceText.replace(/[^\d.]/g, "")) || 0;

    let guestsText = document.getElementById("guests")?.value || "0";
    let guestsValue = parseInt(guestsText) || 0;

    const phoneInput = document.getElementById("phoneNo");
    let phone;
    if (window.itiInstance) {
        phone = window.itiInstance.getNumber() || "";
    } else {
        let plusCode = phoneInput?.closest('.iti')?.querySelector('.iti__selected-dial-code')?.textContent || "";
        phone = plusCode + (phoneInput?.value.trim() || "").replace(/\D/g, "");
    }

    const bookingDraft = {
        flatId: window.flatId,
        startDate: document.getElementById("arrival-date")?.value,
        endDate: document.getElementById("departure-date")?.value,
        price: priceValue,
        guestsCount: guestsValue,
        guestData: { phone }
    };
    localStorage.setItem("bookingDraft", JSON.stringify(bookingDraft));
}

document.addEventListener("DOMContentLoaded", async function () {
    let wasAttemptingToBook = false;
    const bookingModal = document.getElementById('booking-modal');
    const preBookingCalendar = document.getElementById('pre-booking-calendar');
    const mobileBookButton = document.getElementById('bookButton');
    const desktopBookButton = document.getElementById('desktopBookButton');
    
    // Проверяем существование необходимых элементов
    if (!bookingModal) {
        return;
    }

    // closeBookingModal будет добавлен динамически при открытии модального окна
    // Поэтому используем делегирование событий
    bookingModal.addEventListener('click', function (e) {
        if (e.target.id === 'closeBookingModal' || e.target.closest('#closeBookingModal')) {
            closeBookingModal();
        }
    })

    function showBookingModal() {
        if (!bookingModal) return;
        if (window.innerWidth < 768) {
            bookingModal.classList.add('mobile-booking');
        } else {
            bookingModal.classList.remove('mobile-booking');
        }
        
        // Prevent layout shift by compensating for scrollbar width
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.overflow = 'hidden';
        document.body.style.paddingRight = scrollbarWidth + 'px';
        document.body.classList.add('booking-modal-open');
        
        bookingModal.style.display = 'flex';
        
        // Setup intlTelInput dropdown to appear above modal
        setupIntlTelInputDropdown();
        
        // For mobile: prevent touch scroll on modal overlay
        if (window.innerWidth < 768) {
            const overlay = bookingModal.querySelector('.booking-modal-overlay');
            if (overlay) {
                overlay.addEventListener('touchmove', preventScroll, { passive: false });
            }
        }
    }

    function closeBookingModal() {
        if (!bookingModal) return;
        bookingModal.style.display = 'none';
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        document.body.classList.remove('booking-modal-open');
        
        // Remove touch scroll prevention
        const overlay = bookingModal.querySelector('.booking-modal-overlay');
        if (overlay) {
            overlay.removeEventListener('touchmove', preventScroll);
        }
    }
    
    function preventScroll(e) {
        e.preventDefault();
    }

    let intlDropdownInitialized = false;

    function setupIntlTelInputDropdown() {
        if (intlDropdownInitialized) return;
        intlDropdownInitialized = true;

        const phoneInput = document.getElementById('phoneNo');
        if (!phoneInput) return;

        const countryModal   = document.getElementById('countrySelectModal');
        const countryList    = document.getElementById('countryList');
        const searchInput    = document.getElementById('countrySearchInput');
        const closeBtn       = document.getElementById('closeCountryModal');
        if (!countryModal || !countryList || !searchInput) return;


        function getAllCountries() {
            if (typeof window.intlTelInput === 'function' && typeof window.intlTelInput.getCountryData === 'function') {
                return window.intlTelInput.getCountryData();
            }
            return [];
        }

        function getCountryName(country) {
            const i18n = window.intlTelInputRU;
            if (i18n && i18n[country.iso2]) return i18n[country.iso2];
            return country.name || country.iso2.toUpperCase();
        }

        function renderList(filter) {
            const countries = getAllCountries();
            const query     = (filter || '').toLowerCase().trim();

            const filtered = query
                ? countries.filter(c => {
                    const name = getCountryName(c).toLowerCase();
                    const dialCode = c.dialCode || '';
                    return name.includes(query) || dialCode.includes(query);
                })
                : countries;

            countryList.innerHTML = '';
            filtered.forEach(country => {
                const li = document.createElement('li');
                li.className = 'country-select-item';
                li.dataset.iso2 = country.iso2;
                li.dataset.dialCode = country.dialCode;
                li.innerHTML = `
                    <span class="iti__flag iti__${country.iso2}"></span>
                    <span class="country-name">${getCountryName(country)}</span>
                    <span class="country-dial">+${country.dialCode}</span>
                `;
                li.addEventListener('click', () => selectCountry(country));
                countryList.appendChild(li);
            });
        }

        function selectCountry(country) {
            const iti = window.itiInstance;
            if (iti && typeof iti.setCountry === 'function') {
                iti.setCountry(country.iso2);
            }
            closeCountryModal();
        }

        function openCountryModal() {
            if (bookingModal) bookingModal.style.display = 'none';

            searchInput.value = '';
            renderList('');
            countryModal.style.display = 'flex';

            requestAnimationFrame(() => {
                countryModal.classList.add('active');
                searchInput.focus();
            });
        }

        function closeCountryModal() {
            countryModal.classList.remove('active');
            setTimeout(() => {
                countryModal.style.display = 'none';
                if (bookingModal) bookingModal.style.display = 'flex';
            }, 300);
        }

        const itiContainer = phoneInput.closest('.iti') || phoneInput.parentElement;
        if (itiContainer) {
            itiContainer.addEventListener('click', (e) => {
                if (window.innerWidth >= 768) return; // desktop: use native dropdown
                const flagBtn = e.target.closest('.iti__selected-country, .iti__flag-container, .iti__selected-flag');
                if (flagBtn) {
                    e.preventDefault();
                    e.stopPropagation();
                    openCountryModal();
                }
            });
        }

        if (closeBtn) closeBtn.addEventListener('click', closeCountryModal);

        countryModal.addEventListener('click', (e) => {
            if (e.target === countryModal) closeCountryModal();
        });

        searchInput.addEventListener('input', () => renderList(searchInput.value));
    }

    function requestAuthThenOpenBooking() {
        if (!window.isGuest) {
            showBookingModal();
            return;
        }
        wasAttemptingToBook = true;
        $('#loginModal').modal('show');
    }

    async function handleBookingWithPhoneVerification() {
        const phoneInput = document.getElementById("phoneNo");
        if (!phoneInput || !phoneInput.value.trim()) {
            alert("Введите номер телефона");
            return;
        }

        let phone;
        if (window.itiInstance) {
            phone = window.itiInstance.getNumber() || "";
        } else {
            let plusCode = phoneInput.closest('.iti')?.querySelector('.iti__selected-dial-code')?.textContent || "";
            phone = plusCode + phoneInput.value.trim().replace(/\D/g, '');
        }

        try {
            // Сначала пытаемся авторизоваться/зарегистрироваться автоматически
            const authResponse = await PhoneVerification.registerOrLoginDuringBooking(phone);

            if (authResponse.success) {
                // Успешная авторизация - сразу переходим к подтверждению бронирования
                const draft = JSON.parse(localStorage.getItem("bookingDraft") || "{}");

                const confirmResponse = await fetch(window.apiBaseUrl + '/api/v1/bookings/prepare-confirm', {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                    },
                    body: JSON.stringify({
                        flat_id: draft.flatId,
                        start_date: draft.startDate,
                        end_date: draft.endDate,
                        guests_count: draft.guestsCount || 1
                    })
                });

                const confirmData = await confirmResponse.json();
                if (confirmData.success) {
                    // Сохраняем подтверждённый телефон в черновик перед переходом
                    try {
                        const draftRaw = JSON.parse(localStorage.getItem('bookingDraft') || '{}');
                        draftRaw.guestData = { ...(draftRaw.guestData || {}), phone };
                        localStorage.setItem('bookingDraft', JSON.stringify(draftRaw));
                    } catch (_) {}
                    window.location.href = confirmData.data.redirect;
                } else {
                    alert(confirmData.error?.message || 'Ошибка бронирования');
                }
            } else {
                // Автоматическая авторизация не удалась - запускаем процесс верификации телефона
                const verificationResponse = await PhoneVerification.sendVerificationRequest(phone);

                if (verificationResponse.success) {
                    PhoneVerification.showPhoneModal(phone, function () {
                    });

                    const codeBoxes = document.querySelectorAll(".code-box");
                    const submitButton = document.getElementById("submitCode");
                    PhoneVerification.setupCodeInputHandling(codeBoxes, submitButton);
                } else {
                    alert(verificationResponse.message || 'Не удалось отправить код верификации');
                }
            }
        } catch (error) {
            alert('Произошла ошибка: ' + error.message);
        }
    }

    if (mobileBookButton) {
        mobileBookButton.addEventListener('click', function (e) {
            e.preventDefault();

            if (window.isGuest) {
                // Если пользователь не авторизован, запускаем процесс бронирования с верификацией телефона
                showBookingModal(); // Показываем модальное окно для ввода данных
            } else {
                // Если пользователь авторизован, показываем стандартное модальное окно
                requestAuthThenOpenBooking();
            }
        });
    }
    if (desktopBookButton) {
        desktopBookButton.addEventListener('click', function (e) {
            e.preventDefault();

            if (window.isGuest) {
                // Если пользователь не авторизован, запускаем процесс бронирования с верификацией телефона
                showBookingModal(); // Показываем модальное окно для ввода данных
            } else {
                // Если пользователь авторизован, показываем стандартное модальное окно
                requestAuthThenOpenBooking();
            }
        });
    }

    const continueBtn = document.getElementById("continueToBooking");
    if (continueBtn) {
        continueBtn.addEventListener("click", function (e) {
            e.preventDefault();
            if (window.isGuest) {
                wasAttemptingToBook = true;
                $('#loginModal').modal('show');
                return;
            }
            if (preBookingCalendar) preBookingCalendar.style.display = "none";
            showBookingModal();
        });
    }

    const bookingModalOverlay = document.querySelector('.booking-modal-overlay');
    if (bookingModalOverlay) {
        bookingModalOverlay.addEventListener('click', function (e) {
            if (e.target === bookingModalOverlay) {
                closeBookingModal();
            }
        });
    }

    if (bookingModal) {
        let startY = 0;
        let currentY = 0;
        const modalContent = bookingModal.querySelector('.booking-modal-content');
        if (modalContent) {
            modalContent.addEventListener('touchstart', function (e) {
                startY = e.touches[0].clientY;
                currentY = startY;
            });
            modalContent.addEventListener('touchmove', function (e) {
                if (modalContent.scrollTop <= 0 && e.touches[0].clientY > startY) {
                    e.preventDefault();
                    currentY = e.touches[0].clientY;
                    const translateY = currentY - startY;
                    if (translateY > 0) {
                        modalContent.style.transform = `translateY(${translateY}px)`;
                    }
                }
            });
            modalContent.addEventListener('touchend', function () {
                if (currentY - startY > 100) {
                    closeBookingModal();
                }
                modalContent.style.transform = '';
            });
        }
    }

    document.addEventListener('userLoggedIn', function () {
        if (wasAttemptingToBook) {
            wasAttemptingToBook = false;
            setTimeout(showBookingModal, 300);
        }
    });
    $('#loginModal').on('hidden.bs.modal', function () {
        if (wasAttemptingToBook && !window.isGuest) {
            wasAttemptingToBook = false;
            setTimeout(showBookingModal, 300);
        }
    });
    $('#signupModal').on('hidden.bs.modal', function () {
        if (wasAttemptingToBook && !window.isGuest) {
            wasAttemptingToBook = false;
            setTimeout(showBookingModal, 300);
        }
    });

    let bookedDates = [];
    let disabledDates = []; // Даты, которые нужно полностью заблокировать
    // Set-версии для O(1) поиска (критично для onDayCreate — вызывается на каждый день)
    let bookedDatesSet = new Set();
    let disabledDatesSet = new Set();

    // Минимальные ночи: кэш и дедупликация запросов
    const minStayCache = new Map();       // dateISO -> minNights
    const minStayInFlight = new Map();    // dateISO -> Promise

    // Предзагрузка минимальных ночей для диапазона (текущая дата + 6 месяцев)
    async function prefetchMinStayRange() {
        try {
            const today = new Date();
            const from = formatDate(today);
            const sixMonthsLater = new Date(today);
            sixMonthsLater.setMonth(sixMonthsLater.getMonth() + 6);
            const to = formatDate(sixMonthsLater);

            const resp = await fetch(
                `${window.apiBaseUrl}/api/v1/flats/${window.flatId}/min-stay/range?from=${from}&to=${to}`,
                { credentials: 'include' }
            );

            if (!resp.ok) {
                console.warn('Failed to prefetch min-stay range');
                return;
            }

            const data = await resp.json();
            if (data.data?.minStay && typeof data.data.minStay === 'object') {
                // Заполняем кэш данными из диапазона
                Object.entries(data.data.minStay).forEach(([dateISO, minNights]) => {
                    minStayCache.set(dateISO, Number.isFinite(minNights) ? minNights : 1);
                });
            }
        } catch (error) {
            console.warn('Error prefetching min-stay range:', error);
        }
    }

    async function getMinStayForDate(dateISO) {
        if (!dateISO) return (typeof window.minNights === 'number' ? window.minNights : 1);
        if (minStayCache.has(dateISO)) return minStayCache.get(dateISO);
        if (minStayInFlight.has(dateISO)) return minStayInFlight.get(dateISO);

        const p = (async () => {
            try {
                const resp = await fetch(`${window.apiBaseUrl}/api/v1/flats/${window.flatId}/min-stay/for-date?date=${encodeURIComponent(dateISO)}`,
                    { credentials: 'include' }
                );
                if (!resp.ok) throw new Error('bad status');
                const json = await resp.json();
                const data = json.data ?? json;
                const v = Number.isFinite(data.minNights)
                    ? data.minNights
                    : (typeof window.minNights === 'number' ? window.minNights : 1);
                minStayCache.set(dateISO, v);
                return v;
            } finally {
                minStayInFlight.delete(dateISO);
            }
        })();

        minStayInFlight.set(dateISO, p);
        return p;
    }

    // Проверяет, является ли дата первой в закрытом диапазоне
    function isFirstDateOfBlockedRange(dateStr) {
        if (!bookedDatesSet.has(dateStr)) return false;

        // Проверяем, что предыдущий день не заблокирован
        const d = new Date(dateStr);
        d.setDate(d.getDate() - 1);
        const prevDay = formatDate(d);

        return !bookedDatesSet.has(prevDay);
    }

    // Проверяет, является ли дата последней в закрытом диапазоне
    function isLastDateOfBlockedRange(dateStr) {
        if (!bookedDatesSet.has(dateStr)) return false;

        // Проверяем, что следующий день не заблокирован
        const d = new Date(dateStr);
        d.setDate(d.getDate() + 1);
        const nextDay = formatDate(d);

        return !bookedDatesSet.has(nextDay);
    }

    async function fetchBookedDates() {
        try {
            if (typeof bookDates !== 'undefined' && bookDates.length > 0) {
                
                bookedDates = bookDates.flatMap(event => {
                    let startDate = new Date(event.start_date);
                    let endDate = new Date(event.end_date);
                    let dateArray = [];

                    if (event.start_date === event.end_date) {
                        dateArray.push(new Date(startDate));
                    } else {
                        while (startDate <= endDate) {
                            dateArray.push(new Date(startDate));
                            startDate.setDate(startDate.getDate() + 1);
                        }
                    }
                    
                    return dateArray;
                }).map(date => date.toISOString().split('T')[0]);

            // Ограничиваем диапазон дат до окна календаря (сегодня − 1 день … сегодня + 5 мес.)
            // чтобы не раздувать Set тысячами дат за прошлые годы
            const _calFilterStart = new Date();
            _calFilterStart.setDate(_calFilterStart.getDate() - 1);
            const _calFilterStartISO = formatDate(_calFilterStart);
            const _calFilterEnd = new Date(_calFilterStart.getFullYear(), _calFilterStart.getMonth() + 5, 0);
            const _calFilterEndISO = formatDate(_calFilterEnd);
            bookedDates = bookedDates.filter(d => d >= _calFilterStartISO && d <= _calFilterEndISO);

// isFirstDateOfBlockedRange использует bookedDatesSet — заполняем его первым
            bookedDatesSet = new Set(bookedDates);
            disabledDates = bookedDates.filter(date => {
                return !isFirstDateOfBlockedRange(date);
            });
            disabledDatesSet = new Set(disabledDates);
            }
        } catch (error) {
        }
    }

    // Показывает уведомление о том, что дата доступна только для выезда
    function showCheckoutOnlyNotification(dateISO) {
        const dateFormatted = formatDateForDisplay(dateISO);
        const message = `${dateFormatted} доступно только для выезда. Пожалуйста, выберите другую дату заезда.`;

        let notification = document.getElementById('checkout-only-notification');
        if (!notification) {
            notification = document.createElement('div');
            notification.id = 'checkout-only-notification';
            notification.className = 'checkout-notification';

            const calendarContainer = document.querySelector('.flatpickr-calendar');
            if (calendarContainer && calendarContainer.parentElement) {
                calendarContainer.parentElement.insertBefore(notification, calendarContainer.nextSibling);
            }
        }

        notification.textContent = message;
        notification.style.display = 'block';
        notification.style.animation = 'slideDown 0.3s ease-out';

        setTimeout(() => {
            if (notification) {
                notification.style.animation = 'fadeOut 0.3s ease-out';
                setTimeout(() => {
                    notification.style.display = 'none';
                }, 300);
            }
        }, 8000);
    }

    // Показывает информационное уведомление о том, что в этот день возможен только выезд
    function showCheckoutAllowedNotification(dateISO) {
        const dateFormatted = formatDateForDisplay(dateISO);
        const message = `На дату ${dateFormatted} возможен только выезд.`;

        let notification = document.getElementById('checkout-allowed-notification');
        if (!notification) {
            notification = document.createElement('div');
            notification.id = 'checkout-allowed-notification';
            notification.className = 'checkout-notification';

            const calendarContainer = document.querySelector('.flatpickr-calendar');
            if (calendarContainer && calendarContainer.parentElement) {
                calendarContainer.parentElement.insertBefore(notification, calendarContainer.nextSibling);
            }
        }

        notification.textContent = message;
        notification.style.display = 'block';
        notification.style.animation = 'slideDown 0.3s ease-out';

        setTimeout(() => {
            if (notification) {
                notification.style.animation = 'fadeOut 0.3s ease-out';
                setTimeout(() => {
                    notification.style.display = 'none';
                }, 300);
            }
        }, 6000);
    }

    // Подсказка о минимальном количестве ночей для выбранной даты заезда
    function showMinStayNotification(instance, startISO, minNights) {
        try {
            if (!minNights || minNights <= 1) {
                hideMinStayNotification();
                return;
            }

            const calendar = instance?.calendarContainer;
            if (!calendar) return;

            // Ищем выбранную дату именно в этом calendar-контейнере
            const selectedDay = [...calendar.querySelectorAll('.flatpickr-day.selected')]
                .find(day => day.dateObj && formatDate(day.dateObj) === startISO);

            if (!selectedDay) {
                hideMinStayNotification();
                return;
            }

            let el = calendar.querySelector('.min-stay-bubble');
            if (!el) {
                el = document.createElement('div');
                el.className = 'min-stay-bubble';
                if (getComputedStyle(calendar).position === 'static') {
                    calendar.style.position = 'relative';
                }
                calendar.appendChild(el);
            }

            el.textContent = `Мин. ночей ${minNights}`;
            el.style.display = 'block';
            el.style.animation = 'bubbleAppear 0.3s ease-out';

            const calendarRect = calendar.getBoundingClientRect();
            const dayRect = selectedDay.getBoundingClientRect();

            el.style.left = (dayRect.left - calendarRect.left + dayRect.width / 2) + 'px';
            el.style.top = (dayRect.top - calendarRect.top - 10) + 'px';
        } catch (_) {}
    }

    function hideMinStayNotification() {
        // Ищем во всех календарях
        const bubbles = document.querySelectorAll('.min-stay-bubble');
        bubbles.forEach(el => {
            if (el && el.style.display !== 'none') {
                el.style.animation = 'bubbleFadeOut 0.2s ease-out';
                setTimeout(() => {
                    el.style.display = 'none';
                }, 200);
            }
        });
    }

    // Форматирование даты для отображения пользователю
    function formatDateForDisplay(isoDate) {
        const months = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
        const days = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];
        const d = new Date(isoDate);
        if (isNaN(d)) return "";
        return `${d.getDate()} ${months[d.getMonth()]}, ${days[d.getDay()]}`;
    }

    flatpickr.localize(Russian);
    function initCalendar(selector, months = 2, linkedSelector) {
        const today = new Date();
        const maxDate = new Date(today.getFullYear(), today.getMonth() + 4, 0);
        return flatpickr(selector, {
            inline: !linkedSelector,
            mode: "range",
            dateFormat: "Y-m-d",
            disable: [
                // Функция для гибкого контроля заблокированных дат
                function (date) {
                    const dateStr = formatDate(date);
                    // Блокируем только те даты, которые не являются первыми в диапазоне
                    return disabledDatesSet.has(dateStr);
                }
            ],
            clickOpens: true,
            allowInput: false,
            minDate: "today",
            maxDate: maxDate,
            showMonths: months,
            plugins: linkedSelector ? [new rangePlugin({ input: linkedSelector })] : [],
            disableDaysInNextAndPrevMonths: true,
            onChange: handleDateSelection,
            onDayCreate: function(dObj, dStr, fp, dayElem) {
                highlightBookedDays(dObj, dStr, fp, dayElem);

                // Визуальная подсветка дат, недоступных из-за min nights
                if (fp.selectedDates && fp.selectedDates.length === 1) {
                    const start = fp.selectedDates[0];
                    const minN = fp.__minNightsForStart || (typeof window.minNights === 'number' ? window.minNights : 1);
                    const minCheckout = new Date(start);
                    minCheckout.setDate(minCheckout.getDate() + minN);
                    const d = dayElem.dateObj;

                    if (d > start && d < minCheckout) {
                        dayElem.classList.add('min-stay-visual-disabled');
                        dayElem.setAttribute('title', `Минимум ${minN} ночей`);
                    }
                }
            }
        });
    }

    // Единая disable-функция с учётом всех правил (базовые блокировки, bookedDates по обоим направлениям)
    // ВАЖНО: НЕ блокируем даты из-за min nights - иначе flatpickr range не даст выбрать конец диапазона
    function makeDisableFn({ startDateObj, minCheckoutObj, firstBookedAfterStart, lastBookedBeforeStart }) {
        return function (date) {
            const dateStr = formatDate(date);

            // 1) базовая блокировка
            if (disabledDatesSet.has(dateStr)) return true;

            // 2) ВАЖНО: НЕ блокируем даты из-за min nights!
            // Min nights проверяются только в onChange, иначе ломается range выбор

            // 3) ограничения по реально заблокированным датам (из disabledDates)
            if (startDateObj && firstBookedAfterStart && date > startDateObj) {
                if (date >= firstBookedAfterStart) return true;
            }

            // 4) справа-налево
            if (startDateObj && lastBookedBeforeStart && date < startDateObj) {
                if (date <= lastBookedBeforeStart) return true;
            }

            return false;
        };
    }

    // Токен актуальности: инкрементируется при каждом вызове handleDateSelection.
    // Позволяет старым await-ветвям понять, что пользователь уже сделал новый выбор.
    let calendarChangeSeq = 0;

    // -----------------------------------------------------------------------
    // Вспомогатель: изменяет выбранные даты БЕЗ повторного вызова onChange
    // -----------------------------------------------------------------------
    function setDateSilently(instance, dates) {
        isInternalCalendarUpdate = true;
        try {
            instance.setDate(dates, false);
        } finally {
            isInternalCalendarUpdate = false;
        }
    }

    async function handleDateSelection(selectedDates, dateStr, instance) {
        // Защита от рекурсии: если этот onChange вызван из-за setDateSilently — выходим
        if (isInternalCalendarUpdate) return;

        const seq = ++calendarChangeSeq;
        const isActual = () => seq === calendarChangeSeq;

        const continueBtn = document.getElementById("continueToBooking");
        if (continueBtn) {
            continueBtn.disabled = selectedDates.length !== 2;
        }

        // Если выбор очищён — скрываем уведомления
        if (selectedDates.length === 0) {
            hideMinStayNotification();
            return;
        }

        // Проверка для одной выбранной даты (дата заезда)
        if (selectedDates.length === 1) {
            const startDate = selectedDates[0];
            const startISO = formatDate(selectedDates[0]);

            // Сбрасываем поле выезда и цену — после предыдущего диапазона могло остаться старое значение
            updateBookingInputs(startISO, '');
            priceOk = false;
            setBookButtonState();

            // Если это первая дата закрытого диапазона - нельзя использовать для заезда
            if (isFirstDateOfBlockedRange(startISO)) {
                instance.clear();
                // Сбрасываем disable к базовому состоянию
                instance.set('disable', [
                    function (date) {
                        return disabledDatesSet.has(formatDate(date));
                    }
                ]);
                showCheckoutOnlyNotification(startISO);
                return;
            }

            // Находим первую РЕАЛЬНО ЗАБЛОКИРОВАННУЮ дату после выбранной (из disabledDates, не включает checkout-only)
            const firstBookedAfterStart = disabledDates
                .map(d => new Date(d))
                .filter(d => d > startDate)
                .sort((a, b) => a - b)[0];

            // Находим последнюю РЕАЛЬНО ЗАБЛОКИРОВАННУЮ дату перед выбранной (из disabledDates)
            const lastBookedBeforeStart = disabledDates
                .map(d => new Date(d))
                .filter(d => d < startDate)
                .sort((a, b) => b - a)[0];

            // Получаем минимальные ночи для заезда, показываем уведомление
            const minN = await getMinStayForDate(startISO);
            if (!isActual()) return;
            instance.__minNightsForStart = minN; // Сохраняем для визуальной подсветки в onDayCreate
            showMinStayNotification(instance, startISO, minN);
            const startDateObj = selectedDates[0];
            const minCheckoutObj = new Date(startDateObj);
            minCheckoutObj.setDate(minCheckoutObj.getDate() + (Number.isFinite(minN) ? minN : 1));

            // Единая disable-функция
            instance.set('disable', [
                makeDisableFn({
                    startDateObj,
                    minCheckoutObj,
                    firstBookedAfterStart,
                    lastBookedBeforeStart
                })
            ]);

            return;
        }

        if (selectedDates.length === 2) {
            let startDate = formatDate(selectedDates[0]);
            let endDate = formatDate(selectedDates[1]);

            // Проверяем, если дата заезда - первая дата закрытого диапазона
            if (isFirstDateOfBlockedRange(startDate)) {
                instance.clear();
                // Сбрасываем disable к базовому состоянию
                instance.set('disable', [
                    function (date) {
                        return disabledDatesSet.has(formatDate(date));
                    }
                ]);
                showCheckoutOnlyNotification(startDate);
                return;
            }

            // Проверка минимального количества ночей (динамически по дате заезда)
            const nightCount = Math.ceil((selectedDates[1] - selectedDates[0]) / (1000 * 60 * 60 * 24));
            const requiredMinNights = await getMinStayForDate(startDate);
            if (!isActual()) return;
            if (nightCount < requiredMinNights) {
                // UX: оставляем дату заезда, сбрасываем выезд и показываем уведомление
                const startObj = selectedDates[0];
                const startISO = formatDate(startObj);

                setDateSilently(instance, [startObj]);
                instance.__minNightsForStart = requiredMinNights; // Сохраняем для визуальной подсветки

                // Очищаем end input
                updateBookingInputs(startISO, '');
                priceOk = false;
                setBookButtonState();

                // Пересчитываем disable-логику для оставшейся стартовой даты
                const firstBookedAfterStart = disabledDates
                    .map(d => new Date(d))
                    .filter(d => d > startObj)
                    .sort((a, b) => a - b)[0];

                const lastBookedBeforeStart = disabledDates
                    .map(d => new Date(d))
                    .filter(d => d < startObj)
                    .sort((a, b) => b - a)[0];

                const minCheckoutObj = new Date(startObj);
                minCheckoutObj.setDate(minCheckoutObj.getDate() + requiredMinNights);

                instance.set('disable', [
                    makeDisableFn({
                        startDateObj: startObj,
                        minCheckoutObj,
                        firstBookedAfterStart,
                        lastBookedBeforeStart
                    })
                ]);

                showMinStayNotification(instance, startISO, requiredMinNights);
                return;
            }

            // ЗАЩИТА: проверяем, нет ли "пограничной" даты (первой в закрытом диапазоне) внутри выбранного интервала
            // Используем ISO-строки из Set — без лишних new Date()
            const firstBlockedInside = [...bookedDatesSet]
                .filter(function (d) {
                    return d > startDate && d < endDate && isFirstDateOfBlockedRange(d);
                })
                .sort()[0];

            if (firstBlockedInside) {
                // Режем диапазон по этой дате: выезд в "пограничный" день
                setDateSilently(instance, [selectedDates[0], new Date(firstBlockedInside)]);

                // Обновляем поля и показываем инфо-сообщение
                updateBookingInputs(startDate, firstBlockedInside);
                updateNightCount().catch(() => {}); // Пересчитываем цену
                showCheckoutAllowedNotification(firstBlockedInside);

                // Возвращаем базовое правило disable
                instance.set('disable', [
                    function (date) {
                        return disabledDatesSet.has(formatDate(date));
                    }
                ]);

                hideMinStayNotification();
                return; // теперь это реально выход из handleDateSelection
            }

            // ВАЖНО: Проверяем, есть ли заблокированные даты между началом и концом
            // (исключаем первые даты диапазонов, которые доступны для выезда в 12:00 и заезда в 14:00)
            const hasDisabledDatesBetween = [...disabledDatesSet].some(d => d > startDate && d < endDate);

            if (hasDisabledDatesBetween) {
                // Есть заблокированные даты - ищем первую и корректируем (ISO-строки, без new Date в sort)
                const firstBlockedBetweenISO = [...disabledDatesSet]
                    .filter(d => d > startDate && d < endDate)
                    .sort()[0];

                // Корректируем на день до первой заблокированной даты
                let correctedEndDate = new Date(new Date(firstBlockedBetweenISO) - 86400000);
                const correctedISO = formatDate(correctedEndDate);

                // Проверяем, не является ли скорректированная дата первой датой диапазона
                if (isFirstDateOfBlockedRange(correctedISO)) {
                    setDateSilently(instance, [selectedDates[0], correctedEndDate]);
                    endDate = correctedISO;
                    showCheckoutAllowedNotification(correctedISO);
                } else {
                    setDateSilently(instance, [selectedDates[0], correctedEndDate]);
                    endDate = correctedISO;
                }

                updateBookingInputs(startDate, endDate);
                updateNightCount().catch(() => {}); // Пересчитываем цену
                instance.set('disable', [
                    function (date) {
                        return disabledDatesSet.has(formatDate(date));
                    }
                ]);
                return;
            }

            // Проверяем, если дата выезда является первой датой закрытого диапазона - это нормально
            const isEndDateCheckoutOnly = isFirstDateOfBlockedRange(endDate);
            if (isEndDateCheckoutOnly) {
                // Показываем информационное уведомление
                showCheckoutAllowedNotification(endDate);
                updateBookingInputs(startDate, endDate);
                updateNightCount().catch(() => {}); // Пересчитываем цену
                // Сбрасываем disable к базовому состоянию
                instance.set('disable', [
                    function (date) {
                        return disabledDatesSet.has(formatDate(date));
                    }
                ]);
                return;
            }

            // Ищем заблокированные даты между началом и концом
            const firstDisabledDateISO = [...disabledDatesSet]
                .filter(d => d > startDate && d < endDate)
                .sort()[0];

            if (firstDisabledDateISO) {
                // Корректируем на день до первой полностью заблокированной даты
                let correctedEndDate = new Date(new Date(firstDisabledDateISO) - 86400000);
                const correctedISO = formatDate(correctedEndDate);

                // Проверяем, не является ли скорректированная дата первой датой диапазона
                if (isFirstDateOfBlockedRange(correctedISO)) {
                    // Если да, то используем её как дату выезда
                    setDateSilently(instance, [selectedDates[0], correctedEndDate]);
                    endDate = correctedISO;
                    showCheckoutAllowedNotification(correctedISO);
                } else {
                    setDateSilently(instance, [selectedDates[0], correctedEndDate]);
                    endDate = correctedISO;
                }
            }

            updateBookingInputs(startDate, endDate);
            updateNightCount().catch(() => {}); // Пересчитываем цену

            // Сбрасываем disable к базовому состоянию после выбора диапазона
            instance.set('disable', [
                function (date) {
                    return disabledDatesSet.has(formatDate(date));
                }
            ]);
            hideMinStayNotification();
        }
    }

    function highlightBookedDays(dObj, dStr, fp, dayElem) {
        let localDate = formatDate(dayElem.dateObj);
        if (bookedDatesSet.has(localDate)) {
            dayElem.classList.add("booked");

            // Если это первая дата диапазона - доступна для выезда (checkout в 12:00, заезд новых гостей в 14:00)
            if (isFirstDateOfBlockedRange(localDate)) {
                dayElem.classList.add("checkout-only");
                dayElem.setAttribute("title", "Доступно для выезда");
            } else {
                dayElem.setAttribute("title", "Забронировано");
            }
        }
    }

    function formatDate(date) {
        return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
            .toISOString()
            .split("T")[0];
    }

    function getNightWord(nightCount) {
        return nightCount === 1 ? "ночь" : (nightCount >= 2 && nightCount <= 4 ? "ночи" : "ночей");
    }

    // Проверка валидности диапазона для расчёта цены
    function isValidRangeForPricing(arrivalStr, departureStr) {
        if (!arrivalStr || !departureStr) return false;

        const arrival = new Date(arrivalStr);
        const departure = new Date(departureStr);

        if (isNaN(arrival) || isNaN(departure)) return false;
        if (departure <= arrival) return false;

        const arrivalISO = formatDate(arrival);
        const departureISO = formatDate(departure);

        // Нельзя заезжать в день, который является "первым днём закрытого диапазона"
        if (isFirstDateOfBlockedRange(arrivalISO)) {
            return false;
        }

        // Внутри диапазона не должно быть полностью заблокированных дат
        // ISO-строки сравниваются лексикографически корректно — без new Date()
        const hasDisabledInside = [...disabledDatesSet].some(d => d > arrivalISO && d < departureISO);

        if (hasDisabledInside) {
            return false;
        }

        // Внутри диапазона не должно быть "пограничных" дат (checkout-only),
        // через которые мы не даём перепрыгивать
        const hasCheckoutOnlyInside = [...bookedDatesSet].some(
            d => d > arrivalISO && d < departureISO && isFirstDateOfBlockedRange(d)
        );

        if (hasCheckoutOnlyInside) {
            return false;
        }

        // Дата выезда может быть checkout-only (это норм)
        return true;
    }

    async function calculateNightsAndPrice(arrival, departure) {
        const [arrivalDate, departureDate] = [new Date(arrival), new Date(departure)];

        if (!arrival || !departure || departureDate <= arrivalDate) {
            return { nights: 0, totalPrice: 0, basePrice: 0, guestSurcharge: 0, prepayment: 0, remainingPayment: 0 };
        }

        const nights = Math.ceil((departureDate - arrivalDate) / (1000 * 60 * 60 * 24));
        let totalPrice = 0;
        let basePrice = 0;
        let guestSurcharge = 0;
        let extraGuests = null;

        const guestsCount = parseInt(document.getElementById('adults')?.value || '1', 10) || 1;

        try {
            if (priceAbortController) {
                priceAbortController.abort();
            }
            priceAbortController = new AbortController();

            const response = await fetch(`${window.apiBaseUrl}/api/v1/flats/${window.flatId}/prices/calculate?startDate=${arrival}&endDate=${departure}&guests=${guestsCount}`, {
                credentials: 'include',
                signal: priceAbortController.signal
            });
            const data = await response.json();
            totalPrice = data.data?.totalPrice || 0;
            basePrice = data.data?.baseTotal ?? (nights * (window.pricePerNight || 0));
            guestSurcharge = data.data?.guestFeeTotal ?? 0;
            extraGuests = data.data?.priceBreakdown?.extraGuests ?? null;
            priceOk = response.ok && Number.isFinite(totalPrice) && totalPrice >= 0;
        } catch (e) {
            if (e.name === 'AbortError') {
                throw e; // пробрасываем наверх, чтобы updateNightCount тихо вышел
            }
            // при ошибке считаем цену fallback'ом, но кнопку не активируем без успешного API
            totalPrice = nights * (window.pricePerNight || 100);
            basePrice = totalPrice;
            guestSurcharge = 0;
            priceOk = false;
        }

        return {
            nights,
            totalPrice,
            basePrice,
            guestSurcharge,
            extraGuests,
            prepayment: Math.round(totalPrice * 0.25),
            remainingPayment: totalPrice - Math.round(totalPrice * 0.25)
        };
    }

    function updateBookingInputs(start, end) {
        const arrivalInput = document.getElementById("arrival-date");
        const departureInput = document.getElementById("departure-date");

        if (arrivalInput && departureInput) {
            arrivalInput.value = start;
            departureInput.value = end;
        }
    }

    function updateCalendars() {
        const disableFunc = [
            function (date) {
                const dateStr = formatDate(date);
                return disabledDatesSet.has(dateStr);
            }
        ];
        if (datePicker) datePicker.set("disable", disableFunc);
        if (mobilePreBookingCalendar) mobilePreBookingCalendar.set("disable", disableFunc);
        if (arrivaldatePicker) arrivaldatePicker.set("disable", disableFunc);
    }

    // Сначала загружаем заблокированные даты
    await fetchBookedDates();

    // Затем инициализируем календари с уже заполненным disabledDates
    let datePicker = initCalendar(".date-range", getShowMonths());
    let mobilePreBookingCalendar = initCalendar("#mobile-datepicker", 1);
    let arrivaldatePicker = initCalendar("#arrival-date", 1, "#departure-date");

    // Предзагружаем минимальные ночи на 6 месяцев вперёд в фоновом режиме (без await)
    prefetchMinStayRange();

    window.addEventListener('resize', () => {
        datePicker.destroy();
        mobilePreBookingCalendar.destroy();
        arrivaldatePicker.destroy();

        const newMonths = getShowMonths();
        datePicker = initCalendar(".date-range", newMonths);
        mobilePreBookingCalendar = initCalendar("#mobile-datepicker", 1);
        arrivaldatePicker = initCalendar("#arrival-date", 1, "#departure-date");

        updateCalendars();
    });

    function getShowMonths() {
        return window.innerWidth <= 768 ? 1 : 2;
    }

    const calendars = document.querySelectorAll(".flatpickr-calendar.rangeMode");
    calendars.forEach((calendar) => {
        const clearButton = document.createElement("button");
        clearButton.className = "btn clearData";
        clearButton.type = "button";
        clearButton.textContent = "Очистить даты";

        // Добавляем кнопку в календарь
        calendar.appendChild(clearButton);

        // Добавляем обработчик клика для очистки дат
        clearButton.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            
            const arrivalInput = document.getElementById("arrival-date");
            const departureInput = document.getElementById("departure-date");

            // Очищаем все календари
            if (arrivalInput && arrivalInput._flatpickr) {
                arrivalInput._flatpickr.clear();
            }
            if (mobilePreBookingCalendar) {
                mobilePreBookingCalendar.clear();
            }
            if (datePicker) {
                datePicker.clear();
            }
            
            // Очищаем значения в инпутах
            if (arrivalInput) arrivalInput.value = '';
            if (departureInput) departureInput.value = '';
            
            // Сбрасываем disable к базовому состоянию для всех календарей
            const baseDisable = [
                function (date) {
                    const dateStr = formatDate(date);
                    return disabledDatesSet.has(dateStr);
                }
            ];
            if (arrivalInput && arrivalInput._flatpickr) {
                arrivalInput._flatpickr.set('disable', baseDisable);
            }
            if (mobilePreBookingCalendar) {
                mobilePreBookingCalendar.set('disable', baseDisable);
            }
            if (datePicker) {
                datePicker.set('disable', baseDisable);
            }
            
            // Скрываем уведомления
            document.querySelectorAll('.checkout-notification').forEach(notif => {
                notif.style.display = 'none';
            });
            
            // Обновляем расчёт цены
            updateNightCount().catch(() => {});
        });
    })

    document.getElementById("backToMain").addEventListener("click", function () {
        if (preBookingCalendar) preBookingCalendar.style.display = "none";
        document.body.style.overflow = '';
    });

    // Обработка нажатия кнопки "Забронировать"
    const bookingButton = document.getElementById("lockDates");
    if (bookingButton) {
        bookingButton.addEventListener("click", async function (event) {
            event.preventDefault();

            const phoneInput = document.getElementById("phoneNo");
            if (!phoneInput || !phoneInput.value.trim()) {
                alert("Введите номер телефона");
                return;
            }

            bookingButton.disabled = true;
            bookingButton.classList.add('is-loading');
            const originalText = bookingButton.textContent;
            bookingButton.textContent = 'Проверяем телефон...';

            try {
                await handleBookingWithPhoneVerification();
            } catch (error) {
                alert('Произошла ошибка: ' + error.message);
            } finally {
                bookingButton.disabled = false;
                bookingButton.classList.remove('is-loading');
                bookingButton.textContent = originalText;
            }
        });
    }

    // Обработка повторной отправки кода
    const resendButton = document.getElementById("resendCode");
    if (resendButton) {
        resendButton.addEventListener("click", async function (event) {
            event.preventDefault();

            const phoneInput = document.getElementById("phoneNo");
            let phone;
            if (window.itiInstance) {
                phone = window.itiInstance.getNumber() || "";
            } else {
                let plusCode = phoneInput?.closest('.iti')?.querySelector('.iti__selected-dial-code')?.textContent || "";
                phone = plusCode + (phoneInput?.value.trim() || "").replace(/\D/g, '');
            }
            if (!phoneInput || !phoneInput.value.trim()) {
                alert("Введите номер телефона");
                return;
            }

            resendButton.disabled = true;
            const originalResendText = resendButton.textContent;
            resendButton.textContent = 'Отправляем...';

            try {
                const response = await PhoneVerification.sendVerificationRequest(phone);

                // Если телефон уже верифицирован при повторной отправке
                if (response.phoneVerified === true) {
                    resendButton.textContent = 'Подтверждаем...';
                    const draft = JSON.parse(localStorage.getItem("bookingDraft") || "{}");

                    fetch(window.apiBaseUrl + '/api/v1/bookings/prepare-confirm', {
                        method: 'POST',
                        credentials: 'include',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                        },
                        body: JSON.stringify({
                            flat_id: draft.flatId,
                            start_date: draft.startDate,
                            end_date: draft.endDate,
                            guests_count: draft.guestsCount || 1
                        })
                    })
                        .then(response => response.json())
                        .then(data => {
                            if (data.success) {
                                resendButton.textContent = 'Перенаправляем...';
                                // Сохраняем подтверждённый телефон в черновик перед переходом
                                try {
                                    const draftRaw = JSON.parse(localStorage.getItem('bookingDraft') || '{}');
                                    draftRaw.guestData = { ...(draftRaw.guestData || {}), phone };
                                    localStorage.setItem('bookingDraft', JSON.stringify(draftRaw));
                                } catch (_) {}
                                window.location.href = data.data.redirect;
                            } else {
                                alert(data.error?.message || 'Ошибка бронирования');
                                resendButton.disabled = false;
                                resendButton.textContent = originalResendText;
                            }
                        })
                        .catch(error => {
                            alert('Произошла ошибка при подтверждении бронирования');
                            resendButton.disabled = false;
                            resendButton.textContent = originalResendText;
                        });
                } else {
                    resendButton.disabled = false;
                    resendButton.textContent = originalResendText;
                }
            } catch (error) {
                alert("Ошибка при повторной отправке: " + error.message);
                resendButton.disabled = false;
                resendButton.textContent = originalResendText;
            }
        });
    }

    ["arrival-date", "departure-date", "guests", "phoneNo"].forEach(id => {
        const el = document.getElementById(id);
        if (!el) return;

        const handler = async () => {
            const a = document.getElementById('arrival-date')?.value;
            const d = document.getElementById('departure-date')?.value;

            if (id === 'arrival-date' || id === 'departure-date') {
                // Просто сбрасываем флаг, но НЕ пересчитываем цену отсюда.
                // Цена пересчитывается только из handleDateSelection,
                // когда flatpickr уже нормализовал диапазон.
                priceOk = false;
            }

            if (id === 'phoneNo') {
                // Дополнительная защита: считаем цену только если диапазон валидный
                if (a && d && !priceOk && !isPricing && isValidRangeForPricing(a, d)) {
                    await updateNightCount();
                }
            }

            setBookButtonState();
            saveBookingDraft();
        };

        el.addEventListener("input", handler);
        el.addEventListener("change", handler);
    });

    const initArrival = document.getElementById('arrival-date')?.value;
    const initDeparture = document.getElementById('departure-date')?.value;
    if (initArrival && initDeparture) {
        await updateNightCount();
    }

    // Форматирует число с пробелом как разделителем тысяч (ru-RU: 30 950)
    function formatPrice(num) {
        return Math.round(num).toLocaleString('ru-RU');
    }

    // Склонение слова "сутки" для числа (за N суток)
    function getDayWord(n) {
        return 'суток';
    }

    // Строит HTML с детализацией расчёта (двухколоночная таблица)
    function buildBreakdownHTML(nights, basePrice, guestSurcharge, totalPrice, extraGuests = null) {
        const dayWord = getDayWord(nights);
        const pricePerNightCalc = nights > 0 ? Math.round(totalPrice / nights) : 0;

        let rows = `
            <div class="price-breakdown__table-row">
                <span>Стоимость проживания за ${nights}&nbsp;${dayWord}</span>
                <span>${formatPrice(basePrice)}&nbsp;BYN</span>
            </div>`;

        if (guestSurcharge > 0 && extraGuests !== 0) {
            const n = extraGuests !== null ? extraGuests : 1;
            const guestLabel = n === 1 ? '1&nbsp;гостя' : n + '&nbsp;гостей';
            rows += `
            <div class="price-breakdown__table-row">
                <span>Доплата за ${guestLabel}</span>
                <span>${formatPrice(guestSurcharge)}&nbsp;BYN</span>
            </div>`;
        }

        return `
            <div>
                ${rows}
                <hr class="price-breakdown__divider">
                <div class="price-breakdown__table-row price-breakdown__total">
                    <span>Итого</span>
                    <strong>${formatPrice(totalPrice)}&nbsp;BYN</strong>
                </div>
                <div class="price-breakdown__per-night">${formatPrice(pricePerNightCalc)}&nbsp;BYN за сутки</div>
            </div>`;
    }

    function updateSidebarPrice(nights, totalPrice, basePrice = 0, guestSurcharge = 0, extraGuests = null) {
        const defaultPricesEl = document.getElementById('sidebar-default-prices');
        const totalEl = document.getElementById('sidebar-total-price');
        const totalAmountEl = document.getElementById('sidebar-total-amount');
        const totalLabelEl = document.getElementById('sidebar-total-label');
        const overlayContentEl = document.getElementById('sidebar-overlay-content');

        const mobileTotalPrice = document.getElementById('mobile-total-price');
        const mobileTotalAmount = document.getElementById('mobile-total-amount');
        const mobileTotalLabel = document.getElementById('mobile-total-label');
        const mobileDefaultPrices = document.getElementById('mobile-default-prices');

        if (nights > 0 && totalPrice > 0) {
            const dayWord = getDayWord(nights);
            const formattedTotal = formatPrice(totalPrice);
            const breakdownHTML = buildBreakdownHTML(nights, basePrice, guestSurcharge, totalPrice, extraGuests);

            // Desktop sidebar
            if (defaultPricesEl) defaultPricesEl.style.display = 'none';
            if (totalEl) totalEl.style.display = '';
            if (totalAmountEl) totalAmountEl.textContent = formattedTotal + ' BYN';
            if (totalLabelEl) totalLabelEl.textContent = `за ${nights} ${dayWord}`;
            if (overlayContentEl) overlayContentEl.innerHTML = breakdownHTML;

            // Overlay закрываем при смене дат
            const overlay = document.getElementById('sidebar-price-overlay');
            if (overlay) overlay.style.display = 'none';

            // Mobile
            if (mobileDefaultPrices) mobileDefaultPrices.style.display = 'none';
            if (mobileTotalPrice) mobileTotalPrice.style.display = 'flex';
            if (mobileTotalAmount) mobileTotalAmount.textContent = formattedTotal + ' BYN';
            if (mobileTotalLabel) mobileTotalLabel.textContent = `за ${nights} ${dayWord}`;
            const priceSheetContent = document.getElementById('price-breakdown-sheet-content');
            if (priceSheetContent) priceSheetContent.innerHTML = breakdownHTML;
        } else {
            // Возвращаем обычные цены
            if (defaultPricesEl) defaultPricesEl.style.display = '';
            if (totalEl) totalEl.style.display = 'none';
            const overlay = document.getElementById('sidebar-price-overlay');
            if (overlay) overlay.style.display = 'none';

            if (mobileDefaultPrices) mobileDefaultPrices.style.display = '';
            if (mobileTotalPrice) mobileTotalPrice.style.display = 'none';
        }
    }

    // --- Desktop: overlay открывается по клику на ⓘ ---
    document.addEventListener('click', function (e) {
        const overlay = document.getElementById('sidebar-price-overlay');
        const infoBtn = document.getElementById('sidebar-price-info-btn');
        const closeBtn = document.getElementById('sidebar-overlay-close');
        if (!overlay) return;

        if (infoBtn && (e.target === infoBtn || infoBtn.contains(e.target))) {
            overlay.style.display = overlay.style.display === 'none' ? '' : 'none';
            return;
        }
        if (closeBtn && (e.target === closeBtn || closeBtn.contains(e.target))) {
            overlay.style.display = 'none';
            return;
        }
        // Закрываем при клике вне overlay (но не на кнопку)
        if (overlay.style.display !== 'none' && !overlay.contains(e.target)) {
            overlay.style.display = 'none';
        }
    });

    // --- Mobile: bottom sheet ---
    const _priceSheet = document.getElementById('price-breakdown-sheet');
    const _priceSheetOverlay = document.getElementById('price-breakdown-sheet-overlay');
    const _priceSheetClose = document.getElementById('price-breakdown-sheet-close');
    const _mobilePriceInfoBtn = document.getElementById('mobile-price-info-btn');

    function openPriceSheet() {
        if (!_priceSheet) return;
        _priceSheet.style.display = '';
        // Блокируем прокрутку страницы (включая iOS Safari)
        const scrollY = window.scrollY;
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = '100%';
        _priceSheet.dataset.scrollY = String(scrollY);
        requestAnimationFrame(() => _priceSheet.classList.add('is-open'));
    }

    function closePriceSheet() {
        if (!_priceSheet) return;
        _priceSheet.classList.remove('is-open');
        // Восстанавливаем прокрутку страницы
        const scrollY = parseInt(_priceSheet.dataset.scrollY || '0', 10);
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, scrollY);
        setTimeout(() => { _priceSheet.style.display = 'none'; }, 300);
    }

    // Блокируем touchmove на overlay (предотвращает прокрутку фона на iOS)
    if (_priceSheetOverlay) {
        _priceSheetOverlay.addEventListener('touchmove', e => e.preventDefault(), { passive: false });
    }

    if (_mobilePriceInfoBtn) _mobilePriceInfoBtn.addEventListener('click', openPriceSheet);
    if (_priceSheetOverlay) _priceSheetOverlay.addEventListener('click', closePriceSheet);
    if (_priceSheetClose) _priceSheetClose.addEventListener('click', closePriceSheet);

    // Свайп вниз для закрытия
    if (_priceSheet) {
        const _panel = _priceSheet.querySelector('.price-breakdown-sheet__panel');
        if (_panel) {
            let _touchStartY = 0;
            _panel.addEventListener('touchstart', e => { _touchStartY = e.touches[0].clientY; }, { passive: true });
            _panel.addEventListener('touchend', e => {
                if (e.changedTouches[0].clientY - _touchStartY > 60) closePriceSheet();
            }, { passive: true });
        }
    }

    // Пре-инициализация дат из URL-параметров (переданных со страницы города)
    if (!initArrival && !initDeparture && window.urlArrivalDate && window.urlDepartureDate) {
        const _urlArrival = window.urlArrivalDate;
        const _urlDeparture = window.urlDepartureDate;
        const _today = formatDate(new Date());

        if (_urlArrival >= _today && _urlDeparture > _urlArrival && isValidRangeForPricing(_urlArrival, _urlDeparture)) {
            // Устанавливаем количество гостей из URL, если передано
            if (window.urlGuests > 0) {
                const adultsInput = document.getElementById('adults');
                if (adultsInput) {
                    const maxG = (typeof window.maxGuests === 'number' && window.maxGuests > 0) ? window.maxGuests : 99;
                    adultsInput.value = String(Math.min(window.urlGuests, maxG));
                }
            }

            // Заполняем поля бронирования
            updateBookingInputs(_urlArrival, _urlDeparture);

            // Выставляем даты в календарях без вызова onChange
            try {
                if (datePicker) setDateSilently(datePicker, [new Date(_urlArrival + 'T00:00:00'), new Date(_urlDeparture + 'T00:00:00')]);
                if (mobilePreBookingCalendar) setDateSilently(mobilePreBookingCalendar, [new Date(_urlArrival + 'T00:00:00'), new Date(_urlDeparture + 'T00:00:00')]);
            } catch (_) {}

            // Активируем кнопку продолжения
            const _continueBtn = document.getElementById('continueToBooking');
            if (_continueBtn) _continueBtn.disabled = false;

            // Пересчитываем цену
            await updateNightCount();
        }
    }

    async function updateNightCount() {
        const arrivalDateInput = document.getElementById("arrival-date");
        const departureDateInput = document.getElementById("departure-date");
        if (!arrivalDateInput || !departureDateInput ||
            !arrivalDateInput.value || !departureDateInput.value) {
            priceOk = false;
            setBookButtonState();
            updateSidebarPrice(0, 0);
            return;
        }

        const arrival = arrivalDateInput.value;
        const departure = departureDateInput.value;

        // Не считаем цену для некорректных диапазонов
        if (!isValidRangeForPricing(arrival, departure)) {
            priceOk = false;
            setBookButtonState();
            updateSidebarPrice(0, 0);
            return;
        }

        // Проверка динамического минимума ночей перед расчётом цены
        try {
            const requiredMinNights = await getMinStayForDate(arrival);
            const nightsQuick = Math.ceil((new Date(departure) - new Date(arrival)) / 86400000);
            if (nightsQuick < requiredMinNights) {
                priceOk = false;
                setBookButtonState();
                updateSidebarPrice(0, 0);
                showMinStayNotification(arrivaldatePicker, arrival, requiredMinNights);
                return;
            }
        } catch (_) {}

        // requestId объявляем ВНЕ try, чтобы finally всегда мог его прочитать
        const requestId = ++window.priceRequestId;
        try {
            isPricing = true;
            setBookButtonState();

            // Показываем спинер вместо цены
            const priceElement = document.querySelector("#price-details .totalPriceSpan");
            if (priceElement) {
                priceElement.innerHTML = '<i class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></i>';
            }

            const { nights, totalPrice, basePrice, guestSurcharge, extraGuests } = await calculateNightsAndPrice(arrival, departure);
            // если это уже не самый свежий ответ — игнорируем обновление DOM
            if (requestId !== window.priceRequestId) {
                return;
            }
            const pe = document.getElementById("price-details")?.querySelector(".totalPriceSpan");
            if (pe) pe.textContent = `${totalPrice} BYN`;
            const nc = document.getElementById("night-count");
            if (nc) nc.textContent = nights;
            const nw = document.getElementById("night-word");
            if (nw) nw.textContent = getNightWord(nights);
            updateSidebarPrice(nights, totalPrice, basePrice, guestSurcharge, extraGuests);
            saveBookingDraft();
        } catch (e) {
            if (e.name === 'AbortError') return; // новый запрос уже в пути, не трогаем DOM
            // Восстанавливаем предыдущее значение при ошибке
            const priceElement = document.querySelector("#price-details .totalPriceSpan");
            if (priceElement && priceElement.innerHTML.includes('glyphicon-refresh')) {
                priceElement.textContent = '0 BYN';
            }
            updateSidebarPrice(0, 0);
        } finally {
            // Сбрасываем флаг ВСЕГДА — isPricing не должен оставаться true при любом сценарии.
            // Если в полёте есть более свежий запрос, он уже выставил isPricing = true сам.
            if (requestId === window.priceRequestId) {
                isPricing = false;
                setBookButtonState();
            }
        }
    }

    function setupBooking() {
        const guestsInput = document.getElementById(`guests`);
        const guestSelectionPanel = document.getElementById(`guestSelectionPanel`);
        const cancelButton = document.getElementById(`cancelGuestInfo`);
        const decrementBtnAdults = document.getElementById(`decrement`);
        const incrementBtnAdults = document.getElementById(`increment`);
        const guestsInputWrapper = document.querySelector(`.guests-input-wrapper`);
        const guestsGroup = document.querySelector(`.input-group.guests`);
        const adults = document.getElementById(`adults`);

        if (!guestsInput || !guestSelectionPanel || !guestsInputWrapper || !guestsGroup || !adults) {
            return;
        }

        guestsInput.addEventListener('click', function (event) {
            event.preventDefault();

            guestsGroup.classList.add('active');
            guestsInputWrapper.classList.toggle('open');

            if (guestSelectionPanel.style.display === 'block') {
                guestSelectionPanel.style.display = 'none';
            } else {
                guestSelectionPanel.style.display = 'block';
            }
        });

        document.addEventListener('click', function (event) {
            if (guestsGroup && !guestsGroup.contains(event.target)) {
                guestsGroup.classList.remove('active');
            }
        });

        // Функция для склонения чисел
        function getDeclension(number, singular, dual, plural) {
            if (number % 10 === 1 && number % 100 !== 11) {
                return singular; // Например: "1 взрослый"
            } else if (
                (number % 10 >= 2 && number % 10 <= 4) &&
                !(number % 100 >= 12 && number % 100 <= 14)
            ) {
                return dual; // Например: "2 взрослых"
            } else {
                return plural; // Например: "5 взрослых"
            }
        }

        // Кнопка "Отмена"
        if (cancelButton) {
            cancelButton.addEventListener('click', function () {
                guestSelectionPanel.style.display = 'none';
            });
        }

        // Функция для обновления значения в поле "Для кого"
        function updateGuestInput() {
            const values = [];
            if (adults.value > 0) {
                values.push(`${adults.value} ${getDeclension(adults.value, 'гость', 'гостя', 'гостей')}`);
            }
            guestsInput.value = values.join(', ');
        }

        updateGuestInput();

        adults.addEventListener('input', async function () {
            updateGuestInput();
            await updateNightCount();
        });

        document.addEventListener('click', function (event) {
            if (
                guestSelectionPanel && !guestSelectionPanel.contains(event.target) &&
                event.target !== guestsInput
            ) {
                guestSelectionPanel.style.display = 'none';
                if (guestsInputWrapper) {
                    guestsInputWrapper.classList.remove('open'); // Убираем класс "open"
                }
            }
        });

        if (decrementBtnAdults) {
            decrementBtnAdults.addEventListener('click', async function (event) {
                event.preventDefault();
                let value = parseInt(adults.value);
                const minVal = parseInt(adults.getAttribute('min') || '1', 10) || 1;
                if (value > minVal) {
                    adults.value = value - 1;
                    updateGuestInput();
                    saveBookingDraft();
                    await updateNightCount();
                }
            });
        }

        if (incrementBtnAdults) {
            incrementBtnAdults.addEventListener("click", async function (event) {
                event.preventDefault();
                let value = parseInt(adults.value);
                const maxGuests = (typeof window.maxGuests === 'number' && window.maxGuests > 0) ? window.maxGuests : null;
                if (maxGuests !== null) {
                    adults.setAttribute('max', String(maxGuests));
                }
                const nextVal = value + 1;
                if (maxGuests === null || nextVal <= maxGuests) {
                    adults.value = nextVal;
                }
                updateGuestInput();
                saveBookingDraft();
                await updateNightCount();
            });
        }

        adults.setAttribute('min', '1');
        if (typeof window.maxGuests === 'number' && window.maxGuests > 0) {
            adults.setAttribute('max', String(window.maxGuests));
            if (parseInt(adults.value) > window.maxGuests) {
                adults.value = String(window.maxGuests);
                updateGuestInput();
            }
        }
    }

    setupBooking('');
    setBookButtonState();

    // $('.booking-how-it-works').on('click', function (e) {
    //     e.preventDefault();
    //     $('#howBookingWorksModal').modal('show');
    // });
});
